import React from 'react';
import { Totals } from '../../../../tabs/GainLoss/Components/Totals/Totals';
import { useIsEmbeddedMobile } from '../../../../../_hooks/useIsEmbeddedMobile';
import { useUnrealizedGainLoss } from '../../../../hooks/useUnrealizedGainLoss';
import { TotalsLoading } from '../../../../tabs/GainLoss/Components/Totals/Totals.loading';

interface Props {
  title: string;
}

export const UnrealizedGainLossSummaryCard = ({ title }: Props) => {
  const isEmbeddedMobile = useIsEmbeddedMobile();

  const { isFetching, data } = useUnrealizedGainLoss();

  if (isFetching) {
    return <TotalsLoading isEmbeddedMobile={isEmbeddedMobile} title={title} />;
  }

  if (!data) {
    return null;
  }

  const unrealizedGainLossTotals = data?.totals;

  if (
    !unrealizedGainLossTotals ||
    unrealizedGainLossTotals.shortTerm == null ||
    unrealizedGainLossTotals.longTerm == null ||
    unrealizedGainLossTotals.total == null
  ) {
    return null;
  }

  return <Totals gainLossTotals={unrealizedGainLossTotals} title={title} />;
};
